<template>
  <div>
    <div class="row mt10 name-box">
      <div class="col-md-12">
        <div class="row">
          <router-link :to="localizedRoute(getMainCategory.url_path + '?designer=' + designerCode)" class="fs-medium-small weight-400 cl-black author uppercase pl10">
            {{ designerCheck }}
          </router-link>
          <div id="6ea25396-b018-405b-8836-c37b4597eb3c" />
          <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/6ea25396-b018-405b-8836-c37b4597eb3c/script?product=${getCurrentProduct.parentSku}`" />
        </div>
        <h1 class="mb10 mt5 product-name weight-600 serif capitalize">
          {{ getCurrentProduct.name | htmlDecode }}
          <AddToWishlist :product="getCurrentProduct" class="wishlist-button" />
        </h1>
        <div class="price-section mb15">
          <p class="fs-medium-small my5">
            {{ $t('Add to bag') }}
          </p>
          <p class="weight-700 my5">
            {{ getCurrentProduct.price | price(storeView) }}
          </p>
          <p v-if="getCurrentProduct.retail_price" class="align-right fs-medium-small cl-light-gray my5">
            {{ `${$t('Retail price')}:` }} {{ getCurrentProduct.retail_price | price(storeView) }}
          </p>
        </div>
      </div>
    </div>
    <div class="row mx0 pb15" v-observe-visibility="visibilityChanged">
      <add-to-cart
        :text="'Add to cart'"
        :show-price="isFloatingAddToCartButtonVisible"
        :show-price-text="$t('Add to cart for')"
        :product="getCurrentProduct"
        :disabled="isAddToCartDisabled || isProductSold"
        class="col-xs-12 col-sm-12 col-md-12 py10 mb10"
        :class="{ 'floating-add-to-cart-button mb0': isFloatingAddToCartButtonVisible }"
      />
      <p class="col-xs-12 col-sm-12 col-md-12 cl-gray instant-info weight-400 mt0 mb10 p0 fs13" v-show="isInstantCheckoutRegistered && !isVirtualInCart">
        {{ $t('By clicking on one of the following payment method buttons, you confirm that you have read, understood and accept our') }}
        <router-link class="no-underline" target="_blank" rel="noreferrer" :to="localizedRoute('/i/' + $t('rules'))" exact>
          {{ $t('Rules') }}
        </router-link>{{ $t('and') }}
        <router-link class="no-underline" target="_blank" rel="noreferrer" :to="localizedRoute('/i/' + $t('privacy-policy'))" exact>
          {{ $t('Privacy policyV2') }}
        </router-link>
      </p>
      <div class="col-xs-12 col-sm-12 col-md-12 p0 flex mb15">
        <no-ssr>
          <instant-checkout :product="getCurrentProduct" v-show="isInstantCheckoutRegistered && !isVirtualInCart" :disabled="isAddToCartDisabled || isProductSold" @click-add-to-cart="validateProduct()" />
        </no-ssr>
      </div>
      <div class="col-xs-12 product-details">
        <div class="row" v-for="attr in attrs" :key="attr">
          <template v-if="getCurrentProduct[attr]">
            <p class="col-xs-6 my5 detail-name">
              {{ getAllAttributeList(attr) }}
            </p>
            <p class="col-xs-6 my5">
              {{ $t(getAttrValue(attr)) }}
            </p>
          </template>
        </div>
      </div>
      <span class="cl-error align-center h5 w-100" v-if="isAddToCartDisabled && !getIsStockInfoLoading">{{ $t('Brak produktu na stanie') }}</span>
      <!-- <span class="cl-error align-center h5 w-100" v-else-if="isAddToCartDisabled && !isStockInfoLoading">{{ $t('Wybrany sposób dostawy nie jest dostępny') }}</span> -->
      <span class="cl-error align-center h5 w-100 flex mt5 center-xs" v-show="isAddingToCart"><Spinner /> {{ $t('Rezerwujemy ten produkt') }}</span>
    </div>
  </div>
</template>

<script>
import { notifications } from '@vue-storefront/core/modules/cart/helpers'
import { ProductMixin } from 'theme/components/core/blocks/Product-v2/ProductMixin.ts'
import { mapGetters } from 'vuex'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { isMarketplaceProductSold } from 'theme/helpers/selling-products'

const WHITE_LIST_ATTRS = [
  'marketplace_condition',
  'basic_color',
  'size',
  'shoe_size',
  'fabric',
  'jewellery_material',
  'dress_length',
  'marketplace_purchase_year',
  'marketplace_fabric',
  'worek_przeciwkurzowy',
  'rachunek',
  'pudelko',
  'wymiary'
]

export default {
  name: 'SimpleProduct',
  mixins: [ProductMixin],
  data () {
    return {
      isFloatingAddToCartButtonVisible: true
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      attributeListByCode: 'attribute/attributeListByCode',
      getIsStockInfoLoading: 'stock/getIsStockInfoLoading'
    }),
    storeView () {
      return currentStoreView()
    },
    langCode () {
      return this.storeView.i18n.defaultLocale.replace('-', '_')
    },
    attrs () {
      return WHITE_LIST_ATTRS
    },
    isProductSold () {
      return isMarketplaceProductSold(this.getCurrentProduct.marketplace_sold_at, this.getCurrentProduct.type_id)
    },
    designerCode () {
      return this.getCurrentProduct.designer || this.getCurrentProduct.marketplace_designer
    },
    isAddToCartDisabled () {
      return this.getIsStockInfoLoading ||
      (this.isOnline && !this.getMaxQuantity && this.getCurrentProduct.type_id === 'simple')
    }
  },
  mounted () {
    this.$bus.$on('product-after-load', this.setProductCarierCode)
    this.setProductCarierCode()
  },
  beforeDestroy () {
    this.$bus.$off('product-after-load', this.setProductCarierCode)
  },
  methods: {
    setProductCarierCode () {
      this.$store.state.product.current.product_option.extension_attributes.carrier_code = 'any'
    },
    validateProduct () {
      this.isHideValidation = !!this.date
    },
    async addToCart () {
      try {
        const diffLog = await this.$store.dispatch('cart/addItem', { productToAdd: this.getCurrentProduct })
        diffLog.clientNotifications.forEach(notificationData => {
          this.notifyUser(notificationData)
        })
      } catch (message) {
        this.notifyUser(notifications.createNotification({ type: 'error', message }))
      }
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    },
    getAttrValue (attr) {
      if (this.attributeListByCode[attr].frontend_input === 'text') return this.getCurrentProduct[attr]
      return this.getLabelFor(attr)
    },
    visibilityChanged(isVisible, entry) {
      const isElementVisible = isVisible;
      const isViewportBelowElement = entry.boundingClientRect.bottom <= 0;

      if (isElementVisible || isViewportBelowElement) this.isFloatingAddToCartButtonVisible = false;
      else this.isFloatingAddToCartButtonVisible = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.product-name {
  font-size: 28px;
  font-weight: 500;
  position: relative;
  .wishlist-button {
    margin-right: -17px;
    position: absolute;
    right: 0;
    top: -7px;
  }
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
.instant-info, .instant-info > * {
  color: #676776;
  font-size: 13px;
  line-height: 20px;
}
.price-section {
  padding: 12px 20px;
  border: 1px solid #D1D1D1;
  background-color: #F5F5F5;
}
.product-details {
  padding: 12px 20px;
  font-size: 12px;
  border: 1px solid #D1D1D1;
}
.detail-name {
  text-transform: uppercase;
  letter-spacing: 0.55px;
  font-weight: bold;
}
.fs13 {
  font-size: 13px;
}
.floating-add-to-cart-button {
  position: fixed;
  z-index: 999;
  bottom: 50px;
  left: 25px;
  right: 24px;
  &.disabled {
    opacity: 1;
    background-color: #d9d9d9;
  }
}
</style>
